import React, { ReactNode } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { EditCandidateProfileStore } from './edit-candidate-profile.store';

const EditCandidateProfileContext = React.createContext<EditCandidateProfileStore | null>(null);

export const EditCandidateProfileProvider = ({ children }: { children: ReactNode }) => {
   const navigate = useNavigate();
   const { slug = '' } = useParams();
   const [store] = React.useState(() => new EditCandidateProfileStore(slug, navigate));

   return (
      <EditCandidateProfileContext.Provider value={store}>
         {children}
      </EditCandidateProfileContext.Provider>
   );
};

export const useEditCandidateProfile = () => {
   const ctx = React.useContext(EditCandidateProfileContext);
   if (!ctx) {
      throw new Error('useEditCandidateProfile must be used inside EditCandidateProfileProvider');
   }
   return ctx;
};
